import React from 'react';
import { Check, Edit3, X, RotateCcw, Star } from 'lucide-react';
import { PLATFORM_COLORS, PLATFORM_TEXT, parseGenres, parseRatings } from '../constants';

export default function ContentCard({ item, isWatched, onCardClick, onEdit, onDelete, onMarkWatched, onMarkPending }) {
  const genres = parseGenres(item.genre);
  const rt = parseRatings(item.ratings_json);

  return (
    <div className="bg-cinema-card border border-cinema-border rounded-xl overflow-hidden card-glow transition-all duration-200 group relative">
      {/* Action buttons — always visible, top-right */}
      <div className="absolute top-2 right-2 flex gap-1.5 z-10">
        {!isWatched ? (
          <button onClick={(e) => { e.stopPropagation(); onMarkWatched(item); }}
            className="action-btn bg-emerald-600/90 hover:bg-emerald-500 text-white shadow-lg" title="Marcar como visto">
            <Check size={18} strokeWidth={3} />
          </button>
        ) : (
          <button onClick={(e) => { e.stopPropagation(); onMarkPending(item); }}
            className="action-btn bg-amber-600/90 hover:bg-amber-500 text-white shadow-lg" title="Volver a pendientes">
            <RotateCcw size={16} />
          </button>
        )}
        <button onClick={(e) => { e.stopPropagation(); onEdit(item); }}
          className="action-btn bg-cinema-accent/90 hover:bg-cinema-accent text-white shadow-lg" title="Editar">
          <Edit3 size={16} />
        </button>
        <button onClick={(e) => { e.stopPropagation(); onDelete(item); }}
          className="action-btn bg-red-600/90 hover:bg-red-500 text-white shadow-lg" title="Eliminar">
          <X size={18} strokeWidth={3} />
        </button>
      </div>

      {/* Click zone for detail */}
      <div className="cursor-pointer" onClick={() => onCardClick(item)}>
        {/* Poster */}
        <div className="relative aspect-[2/3] bg-steel-800">
          {item.poster ? (
            <img src={item.poster} alt={item.title} className="w-full h-full object-cover" loading="lazy"
              onError={(e) => { e.target.style.display = 'none'; }} />
          ) : (
            <div className="w-full h-full flex items-center justify-center text-5xl">
              {item.type === 'series' ? '📺' : '🎬'}
            </div>
          )}
          {/* Rating badges on poster bottom-left */}
          <div className="absolute bottom-2 left-2 flex items-center gap-1.5">
            {item.imdb_rating && (
              <span className="flex items-center gap-0.5 bg-black/80 text-yellow-400 px-1.5 py-0.5 rounded-md text-xs font-bold backdrop-blur-sm">
                <Star size={10} fill="currentColor" />{item.imdb_rating}
              </span>
            )}
            {rt.rt && (
              <span className="bg-black/80 text-white px-1.5 py-0.5 rounded-md text-xs font-medium backdrop-blur-sm">
                🍅{rt.rt}
              </span>
            )}
          </div>
        </div>

        {/* Info */}
        <div className="p-2.5">
          <h3 className="text-white font-semibold text-sm leading-snug line-clamp-2 mb-1">{item.title}</h3>
          <div className="flex items-center gap-1.5 text-steel-400 text-xs mb-1.5 flex-wrap">
            <span>{item.year}</span>
            {item.type === 'series' && item.total_seasons && <span>{item.total_seasons}T</span>}
            {item.runtime && <span>{item.runtime}m</span>}
            <span>{item.type === 'series' ? '📺' : '🎬'}</span>
          </div>

          {/* Platform */}
          {item.platform && (
            <span className="inline-block px-2 py-0.5 rounded text-[11px] font-medium platform-badge mb-1.5"
              style={{ background: PLATFORM_COLORS[item.platform] || '#333', color: PLATFORM_TEXT[item.platform] || '#fff' }}>
              {item.platform}
            </span>
          )}

          {/* Genres */}
          {genres.length > 0 && (
            <div className="flex flex-wrap gap-1">
              {genres.slice(0, 2).map(g => (
                <span key={g} className="text-[10px] text-steel-400 bg-steel-800 px-1.5 py-0.5 rounded">{g}</span>
              ))}
              {genres.length > 2 && (
                <span className="text-[10px] text-steel-500 bg-steel-800 px-1.5 py-0.5 rounded">+{genres.length - 2}</span>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
